var map = {
	"./aziz-profile-pic.webp": 7674,
	"./banners/banner0.webp": 3613,
	"./banners/banner1.webp": 401,
	"./charters.webp": 4105,
	"./footer.webp": 7026,
	"./pic-section0-0.webp": 6052,
	"./pic-section0-1.webp": 9448,
	"./pic-section0-2.webp": 917,
	"./pic-section1-0.webp": 7762,
	"./pic-section1-1.webp": 3321,
	"./pic-section1-2.webp": 4274,
	"./schs-mainlogo.png": 5430,
	"./services-0.webp": 2678,
	"./services-1.webp": 2658,
	"./services-2.webp": 8923,
	"./services-3.webp": 3911,
	"./services-background.webp": 944,
	"./vehicle-0.webp": 7016,
	"./vehicle-1.webp": 396,
	"./vehicle-2.webp": 2155,
	"./vehicle-3.webp": 5976,
	"./vehicle-4.webp": 5601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;